import * as api from '../../services/group_type/api_group_type';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as SagaCommon from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListGroupTypeSaga(feathersApp) {
    yield takeLatest('FETCH_LIST_GROUP_TYPE', callFetchListGroupType, feathersApp);
}

function* callFetchListGroupType(feathersApp, action) {
    const { silent, filters } = action;
    yield SagaCommon.showProgressListTable(silent);
    try {
        const dataParams = { 
            filters, 
            list_type: 'group_type'
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
    } catch (error) {
        yield SagaCommon.showErrorListTable(error);
    }
}

export function* saveGroupTypeSaga(feathersApp) {
  yield takeEvery("SAVE_GROUP_TYPE", callSaveGroupType, feathersApp);
}
function* callSaveGroupType(feathersApp, action) {
  const { tenant, user } = yield select();
  try{
      yield put({ type: 'SAVE_RECORD_INPROGRESS' });

      const params = { tenant, user, data: action.data };
      const result = yield call(api.saveGroupType, feathersApp, params );

      yield put({ type: SagasType.SIMPLE_FORM_SET_DATA, data: result });
      yield SagaCommon.doneSaveRecord( result, 'Group Type was saved' );
      yield callFetchListGroupType(feathersApp, { silent: true });

  } catch (e){
    yield SagaCommon.showErrorSaveRecord(e);
  }
}

export function* deleteGroupTypeFromListSaga(feathersApp) {
    yield takeEvery('DELETE_GROUP_TYPE_FROM_LIST', callDeleteGroupTypeFromList, feathersApp);
}

function* callDeleteGroupTypeFromList(feathersApp, action) {
    yield deleteGroupType(feathersApp, action);
    yield delay(2000); 
    yield callFetchListGroupType(feathersApp, { silent: true });
}

function* deleteGroupType(feathersApp, action) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
    try {
        const { id } = action;
        let result = null;
        if(id) {
            const state = yield select();
            const { tenant, user } = state;
            const params = { tenant, user, id };
            result = yield call(api.deleteGroupType, feathersApp, params);
            yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.GROUP_TYPE }});
            yield callFetchListGroupType(feathersApp, { silent: true });
        }
        return result;
    } catch (error) {
        yield put({ type: 'DELETE_RECORD_ERROR', error })
    }
}

export function* deleteGroupTypeSaga(feathersApp) {
    yield takeEvery('DELETE_GROUP_TYPE', callDeleteGroupType, feathersApp);
}

function* callDeleteGroupType(feathersApp, action) {
    const result = yield deleteGroupType(feathersApp, action);
    yield delay(2000); 
    if(result) {
        browserHistory.push('/admin/group_type');
    }
}

export function* fetchGroupTypeForEditSaga(feathersApp) {
    yield takeEvery('FETCH_GROUP_TYPE_BY_ID', callFetchGroupTypeForEdit, feathersApp);
}

function* callFetchGroupTypeForEdit(feathersApp, action) {
    const { tenant, user } = yield select();
    const { id } = action;
    const docType = DocType.GROUP_TYPE;
    try {
        if(id) {
            yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
            const fetchParams = { tenant, user, id };
            const doc = yield call(api.fetchGroupTypeById, feathersApp, fetchParams);
            yield SagaCommon.doneDataById(doc);
            yield put({
              type: SagasType.SIMPLE_FORM_SET_DATA,
              data: doc
            });
        }
    } catch (error) {
        yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
    }
}
